//////////////////////////////////////////////////////////
//                                                      //   
//  PARA TODOS OS USUÁRIOS:                             //   
//                                                      //   
//  APARECE COMO PREÇO NA PARDE DE BAIXO                //
//  DOS CARDS DE PRODUTO NA PÁGINA HOME                 //   
//                                                      //   
//  FUNCIONALIDADE: MOSTRAR O PREÇO DOS PRODUTOS        //    
//                                                      //   
//////////////////////////////////////////////////////////    



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/components/preco_picture.js                        //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



import '../assets/css/local/preco.css';

function Preco(props) {

    // FORMATA O PRECO UNITÁRIO (FORMATO XX.Y PARA XX,YY) 
    var preco = props.props.preco.toString()

    var preco_lista = preco.split('.')
    
    if(preco_lista.length === 2){
        var cents = preco_lista[1]
        
        if(cents.length === 1){
            cents = cents + '0'
        }
        if(cents.length > 2){
            cents = cents.slice(0, 2)
        }

        preco_lista[1] = cents
    }
    else if (preco_lista.length === 1){
        cents = '00'
        preco_lista.push(cents)
    }


    var preco_final = preco_lista.join(',')


    return (  // RENDERIZA O COMPONENTE
        <div class='mb-4'>
            <h5 id={'preco' + props.id} class="preco">R$ {preco_final}</h5>
        </div>
    );
}

export default Preco;
  